import { Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import ResponsiveContainer from '../../../../../components/ResponsiveContainer';
import { useSiniestroContext } from '../../../../../context/siniestro-context';
import Camara from '../../../../../static/autos/Camara.jpg';
import { cards } from '../CarUtil';
import Tarjeta from '../Tarjeta';

const { Title, Paragraph } = Typography;

export default function FotografiasVehiculos(props) {
  const { start } = props;
  const { datosSiniestro, images } = useSiniestroContext();
  const [imagenAdicional, setImagenAdicional] = useState(null);
  const [pasos, setPasos] = useState([
    {
      key: 1,
      card: cards[0],
      delete: false
    },
    { key: 2, card: cards[1], delete: false },
    { key: 3, card: cards[2], delete: false }
  ]);
  const [step, setStep] = useState(pasos.length - 1);

  function whatStep() {
    for (let index = 0; index < images.length; index += 1) {
      const item = images.find((element) => element.paso_nro === index + 1);
      if (!item) {
        return index;
      }
    }
    return 2;
  }

  const initSteps = () => {
    let aux = [];
    const adicionales = [];
    const count = images.length;
    const auxAdicional = images.filter((e) => e?.paso_nro > 3);
    auxAdicional.forEach((e) => {
      const cardAdicional = {
        item: `${e.paso_nro}`,
        key: e.paso_nro,
        image: Camara,
        parte: 'Foto Adicional',
        check: false
      };
      adicionales.push({
        key: e.paso_nro,
        card: cardAdicional,
        delete: true
      });
    });
    aux = [...pasos, ...adicionales];
    if (!start) setStep(count ? count - 1 : count);
    else setStep(0);
    setPasos(aux);
  };

  const back = async () => {
    if (step === 0) {
      props.back();
    }
    setStep(step - 1);
  };

  const next = () => {
    if (step === pasos.length - 1) props.next();
    setStep(step + 1);
  };

  const eliminarPaso = (llave) => {
    setPasos(pasos.filter((e) => e.key !== llave));
    setStep(step - 1);
  };

  const addStep = () => {
    const key = pasos[step].key + 1;
    const card = {
      item: `${key}`,
      key,
      image: Camara,
      parte: 'Fotografía Adicional',
      check: false
    };
    setPasos([...pasos, { key, card, delete: true }]);
    setStep(step + 1);
  };

  useEffect(() => {
    if (images.length < 3) {
      if (props.continue) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
        setStep(whatStep());
      }
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    initSteps();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <ResponsiveContainer>
        <div>
          <Paragraph align="center">
            Favor tomar fotografías desde su Dispositivo Móvil/Celular de los
            daños sufridos a consecuencia del siniestro:
          </Paragraph>
          <Title level={3} align="center">
            Fotos del Vehículo Asegurado
          </Title>
        </div>
        <Tarjeta
          key={pasos[step].key}
          card={pasos[step].card}
          imagenes={images}
          next={next}
          back={back}
          siniestro={datosSiniestro}
          addStep={addStep}
          moreImages={step === pasos.length - 1}
          delete={pasos[step].delete}
          eliminarPaso={eliminarPaso}
          setImagenAdicional={setImagenAdicional}
          imagenAdicional={imagenAdicional}
          enabled={step > 2}
        />
      </ResponsiveContainer>
    </>
  );
}
